// extracted by mini-css-extract-plugin
export default {"container":"pending_container__AriPP","img":"pending_img__OJt36"};